import moment from 'moment';
import Rule from './rule';

export default class DateRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'DATE';
    this.compile(ruleText);
  }

  compile(text) {
    const rule = text.replace(/^\s?date /i, '');
    this.args = rule.split(/\sto\s/i).map(arg => arg.trim());
  }

  run(input) {
    const date = moment(input, this.args[0]);
    return date.isValid() ? date.format(this.args[1]) : '';
  }

  validate() {
    return this.args.length === 2 && this.args[0] !== '' && this.args[1] !== '';
  }
}
